import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'thera-expand-icon-renderer',
    standalone: true,
    imports: [CommonModule],
    templateUrl: "./expand-icon-renderer.component.html",
    styleUrls: ["./expand-icon-renderer.component.scss"]
})
export class ExpandIconRendererComponent implements ICellRendererAngularComp {
    params?: ICellRendererParams;
    isToggleExpanded = false;

    agInit(params: ICellRendererParams): void {
        this.params = params;
        this.isToggleExpanded = params.data?.isRowExpanded ?? false;
    }

    refresh(params: ICellRendererParams): boolean {
        this.params = params;
        this.isToggleExpanded = params.data?.isRowExpanded ?? false;
        return true;
    }

    onExpandClick(event: Event): void {
        event.stopPropagation();

        const { node, data, api } = this.params ?? {};

        if (!node || !data || !api) return;

        data.isRowExpanded = !data.isRowExpanded;
        this.isToggleExpanded = data.isRowExpanded;

        api.redrawRows({ rowNodes: [node] });
    }
}